import { supabase } from "./supabase";

export type ScrollingInfo = {
  message: string;
  published: boolean;
  updatedAt: string | null;
};

type ScrollingInfoRow = {
  message: string;
  published: boolean;
  updated_at: string | null;
};

function normalizeScrollingInfo(row: ScrollingInfoRow): ScrollingInfo {
  return {
    message: row.message,
    published: row.published,
    updatedAt: row.updated_at,
  };
}

export async function readPublishedScrollingInfo(): Promise<ScrollingInfo | null> {
  const { data, error } = await supabase
    .from("site_scrolling_info")
    .select("message,published,updated_at")
    .eq("id", "header")
    .eq("published", true)
    .maybeSingle();

  if (error) throw error;
  return data ? normalizeScrollingInfo(data as ScrollingInfoRow) : null;
}

export async function readAdminScrollingInfo(): Promise<ScrollingInfo | null> {
  const { data, error } = await supabase
    .from("site_scrolling_info")
    .select("message,published,updated_at")
    .eq("id", "header")
    .maybeSingle();

  if (error) throw error;
  return data ? normalizeScrollingInfo(data as ScrollingInfoRow) : null;
}

export async function writeScrollingInfo(input: Pick<ScrollingInfo, "message" | "published">): Promise<ScrollingInfo> {
  const { data, error } = await supabase
    .from("site_scrolling_info")
    .upsert({
      id: "header",
      message: input.message.trim(),
      published: input.published,
      updated_at: new Date().toISOString(),
    }, { onConflict: "id" })
    .select("message,published,updated_at")
    .single();

  if (error) throw error;
  return normalizeScrollingInfo(data as ScrollingInfoRow);
}
